import { Injectable } from '@angular/core'
import { Http, Headers, Response, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/toPromise'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { SeguridadService } from '../_services/seguridad.service'

import { AppSettings } from '../_models/settings.models'

@Injectable()

export class LicenciasService {

    constructor(private http: Http,
                private seguridad: SeguridadService
              ) { }

    getListaLicencias(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "lnGetLicencias", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

            console.log(response);

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getLicencia(id_licencia:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_licencia: id_licencia, tokenid: userToken, action: "lnGetLicencia", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    getTiposLicencia(){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "lngetTipoLicencias", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setLicencia(licencia: any){

      let userToken : string = localStorage.getItem('currentUserToken');

      licencia.tokenid = userToken;
      licencia.action = "lnSetLicencia";
      licencia.api_keytoken = AppSettings.API_KEYTOKEN;

      return this.http.post(AppSettings.API_URL, JSON.stringify(licencia))
          .map((response: Response) => {

              console.log(response);

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setUsuarioLicencia(id_licencia: number, id_ct: number, id_user: number, fecha: string){
      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_licencia: id_licencia, id_user: id_user, implantacion: fecha, id_ct: id_ct, tokenid: userToken, action: "lnSetUsuarioCT", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setUsuarioRoleCT(id_licencia: number, id_ct: number, id_user: number, id_role: number){
      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_licencia: id_licencia, id_user: id_user, id_role: id_role, id_ct: id_ct, tokenid: userToken, action: "lnUnSetUsuarioRoleCT", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }    

    deleteUsuarioLicencia(id_licencia: number, id_ct: number, id_user: number){
      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({ id_licencia: id_licencia, id_user: id_user, id_ct: id_ct, tokenid: userToken, action: "lnUnSetUsuarioCT", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }


}



// WEBPACK FOOTER //
// ./src/app/_services/licencias.service.ts